export default __webpack_public_path__ + "static/media/slide-1-mobile.f5b75ee6.png";